
//门店名称 联系人 联系电话 公司地址 有效期
import {data} from "cheerio/lib/api/attributes";

const columnList: Array<column> = [
    {
        prop: "store_name",
        label: "门店名称",
        width: 200,
    },
    {
        prop: "contacts",
        label: "联系人",
        width: 100,
    },
    {
        prop: "service_phone",
        label: "联系电话",
        width: 100,
    },
    {
        prop: "address",
        label: "公司地址",
        width: 200,
    },
    {
        prop: "end_time_text",
        label: "有效期",
        width: 100,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import {downloadCode, getframeworkList, permissionList} from "@/api/http";
import { column } from "@/assets/types/common";
import { storeUser } from "@/store/User";
export default defineComponent({
    name: "FrameworkManagement",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["门店管理"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            total = ref(0),
            roleList = ref({} as any),
            tableData = ref([] as Array<any>),
            loading = ref(true),
            headClass = inject("headClass"),
            Router = useRouter(),
            user = storeUser.getUser(),
            getTableData = (): void => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'store_manage',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                getframeworkList({
                    page: currentPage.value,
                    pagesize: pageSize.value,
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            },
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            downloadIamge = (imgsrc:string, name:string) => {//下载图片地址和图片名
              let image = new Image();
              // 解决跨域 Canvas 污染问题
              image.setAttribute("crossOrigin", "anonymous");
              image.onload = function () {
                let canvas = document.createElement("canvas");
                canvas.width = image.width;
                canvas.height = image.height;
                let context:any = canvas.getContext("2d");
                context.drawImage(image, 0, 0, image.width, image.height);
                let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

                let a = document.createElement("a"); // 生成一个a元素
                let event = new MouseEvent("click"); // 创建一个单击事件
                a.download = name || "photo"; // 设置图片名称
                a.href = url; // 将生成的URL设置为a.href属性
                a.dispatchEvent(event); // 触发a的单击事件
              };
              image.src = imgsrc;
            },
            Download = (url: string) => {
				let link = document.createElement("a"); //创建a标签
				link.style.display = "none"; //使其隐藏
				link.href = url; //赋予文件下载地址
				link.setAttribute("download", 'img'); //设置下载属性 以及文件名
				document.body.appendChild(link); //a标签插至页面中
				link.click(); //强制触发a标签事件
            },
            downLoadQrcode = (id: number) => {
                let userinfo;
                let jsonData = localStorage.getItem('user_info');
                if(jsonData){
					userinfo = JSON.parse(jsonData);
                }
                let data = {};
                if (userinfo.store_id == 0) {
					data = {
						store_id:id,
					};
                }
				downloadCode(data).then((res:any) => {
					const img_url = res.content;
					if (img_url) {
						window.open(img_url)
					}
                 });
            },
            addShop = () => {
                Router.push({
                    path: "/framework/management/add",
                });
            },
            toEdit = (id: number) => {
                Router.push({
                  path: "/framework/management/edit",
                  query: {
                    id: id,
                  },
                });
            },
            toRole = (id: number) => {
                Router.push({
                  path: "/framework/role",
                  query: {
                    store_id: id,
                  },
                });
            },
            toStaff = (id: number) => {
                Router.push({
                  path: "/personnel/staff",
                  query: {
                    store_id: id,
                  },
                });
            };

        onMounted(() => {
            // var router = useRoute();

            getTableData();
        });

        return {
            columnList,
            tableData,
            loading,
            user,
            headClass,
            Router,
            downLoadQrcode,
            toEdit,
            toRole,
            toStaff,
            handleSizeChange,
            handleCurrentChange,
            total,
            pageSize,
            currentPage,
            roleList,
            addShop
        };
    },
});
